/**
 * Soho69 VIP Bottle Menu — single source of truth.
 * Used by both /tables (browsing) and /book (when reserving a table).
 */

export const BOTTLE_MENU = [
  {
    catKey: "vodka",
    color: "#FF1B8D",
    items: [
      { id: "belvedere-6l", name: "Belvedere 6L", price: 900 },
      { id: "belvedere-1.75l", name: "Belvedere 1.75L", price: 300 },
      { id: "belvedere-1l", name: "Belvedere 1L", price: 150 },
      { id: "grey-goose-1l", name: "Grey Goose 1L", price: 150 },
      { id: "grey-goose-3l", name: "Grey Goose 3L", price: 600 },
      { id: "ciroc-flavours", name: "Cîroc Flavours", price: 150 },
      { id: "au-flavours", name: "Au Flavours", price: 130 },
      { id: "absolut-flavours", name: "Absolut Flavours", price: 100 },
      { id: "smirnoff-1l", name: "Smirnoff", price: 90 },
    ],
  },
  {
    catKey: "gin",
    color: "#FF6BC6",
    items: [
      { id: "bombay", name: "Bombay", price: 90 },
      { id: "tanqueray", name: "Tanqueray", price: 90 },
      { id: "beefeater", name: "Beefeater", price: 90 },
      { id: "gordons", name: "Gordon's", price: 80 },
      { id: "gordons-pink", name: "Gordon's Pink", price: 90 },
    ],
  },
  {
    catKey: "brandy",
    color: "#A655F2",
    items: [
      { id: "hennessy", name: "Hennessy", price: 150 },
      { id: "courvoisier", name: "Courvoisier", price: 150 },
      { id: "chivas-regal", name: "Chivas Regal", price: 150 },
    ],
  },
  {
    catKey: "whiskey",
    color: "#FFC857",
    items: [
      { id: "jack-daniels", name: "Jack Daniel's", price: 90 },
      { id: "jameson", name: "Jameson", price: 90 },
      { id: "southern-comfort", name: "Southern Comfort", price: 90 },
      { id: "red-label", name: "Red Label", price: 90 },
      { id: "black-label", name: "Black Label", price: 90 },
    ],
  },
  {
    catKey: "rum",
    color: "#5BC0FF",
    items: [
      { id: "captain-morgan-spiced", name: "Captain Morgan's Spiced", price: 90 },
      { id: "captain-morgan-dark", name: "Captain Morgan's Dark", price: 90 },
      { id: "arehucas", name: "Arehucas Oro & White", price: 90 },
      { id: "bacardi", name: "Bacardi", price: 90 },
      { id: "havana-club-7", name: "Havana Club 7", price: 90 },
    ],
  },
  {
    catKey: "champagne",
    color: "#FFD37A",
    items: [
      { id: "moet", name: "Moët", price: 150 },
      { id: "moet-ice", name: "Moët Ice", price: 200 },
    ],
  },
];

export const ALL_BOTTLES = BOTTLE_MENU.flatMap((c) => c.items);

export function bottleById(id) {
  return ALL_BOTTLES.find((b) => b.id === id) || null;
}

export function cartTotals(cart) {
  const items = Object.entries(cart || {})
    .map(([id, qty]) => {
      const b = bottleById(id);
      return b ? { ...b, qty } : null;
    })
    .filter(Boolean);
  const count = items.reduce((s, x) => s + x.qty, 0);
  const sum = items.reduce((s, x) => s + (x.price || 0) * x.qty, 0);
  return { items, count, sum };
}

/** Build a single-line description usable as a booking note. */
export function formatBottleNotes(cart, prefix = "Bottle preferences:") {
  const { items } = cartTotals(cart);
  if (items.length === 0) return "";
  const list = items
    .map((x) => `${x.qty}× ${x.name}${x.price ? ` (€${x.price})` : ""}`)
    .join(", ");
  return `${prefix} ${list}`;
}
